import api from "./api";

const referralServices = {
  createReferral(payload: object) {
    return api.post(`/referral?isWeb=${true}`, payload);
  },
};

export default referralServices;
